import React, { ReactNode } from 'react';
import { LoginScreen } from './LoginScreen';
import { useAuth } from '../context/AuthenticationProvider';

/**
 * Verify if user is loggedIn. Start login flow otherwise
 * @param children
 * @constructor
 */
export function WithAuthentication({ children }: { children: ReactNode }): React.ReactElement {
  const { error, isLoading, isLoggedOut, user } = useAuth();

  if (user) {
    return <>{children}</>;
  } else {
    return <LoginScreen error={!!error} loading={isLoading} />;
  }
}
